export default {
    cn: {
        mt4AccountReport: {
            downloadName: 'MT5账户报表',
            loadText: '正在下载,请稍候...',
            tableHead: [
                { key: 'LOGIN', value: '账号' },
                { key: 'NAME', value: '姓名' },
                { key: 'GROUP', value: '组别' },
                { key: 'CURRENCY', value: '入金货币' },
                { key: 'IB_ID', value: '代理账号' },
                { key: 'IB_NAME', value: '代理姓名' },
                { key: 'OFFICE_NAME', value: '所属办事处' },
                { key: 'OID', value: '办事处号码' },
                { key: 'ACC_NAME', value: '所属地区' },
                { key: 'RID', value: '地区编号' },
                { key: 'ZIPCODE', value: '邮编' },
                { key: 'ADDRESS', value: '地址' },
                { key: 'EMAIL', value: '邮箱' },
                { key: 'PHONE', value: '电话号码' },
                { key: 'COMMENT', value: '注释' },
                { key: 'REGDATE', value: '注册日期' },
                { key: 'LEVERAGE', value: '杠杆' },
                { key: 'BALANCE', value: '余额' },
                { key: 'CREDIT', value: '信用额' }
            ]
        }
    },
    hk: {
        mt4AccountReport: {
            downloadName: 'MT5賬戶報表',
            loadText: '正在下載,請稍候...',
            tableHead: [
                { key: 'LOGIN', value: '賬號' },
                { key: 'NAME', value: '姓名' },
                { key: 'GROUP', value: '組別' },
                { key: 'CURRENCY', value: '入金貨幣' },
                { key: 'IB_ID', value: '代理賬號' },
                { key: 'IB_NAME', value: '代理姓名' },
                { key: 'OFFICE_NAME', value: '所屬辦事處' },
                { key: 'OID', value: '辦事處號碼' },
                { key: 'ACC_NAME', value: '所屬地區' },
                { key: 'RID', value: '地區編號' },
                { key: 'ZIPCODE', value: '郵編' },
                { key: 'ADDRESS', value: '地址' },
                { key: 'EMAIL', value: '郵箱' },
                { key: 'PHONE', value: '電話號碼' },
                { key: 'COMMENT', value: '注釋' },
                { key: 'REGDATE', value: '註冊日期' },
                { key: 'LEVERAGE', value: '槓桿' },
                { key: 'BALANCE', value: '餘額' },
                { key: 'CREDIT', value: '信用額' }
            ]
        }
    },
    en: {
        mt4AccountReport: {
            downloadName: 'MT5 Credit Report',
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [
                { key: 'LOGIN', value: 'Login' },
                { key: 'NAME', value: 'Name' },
                { key: 'GROUP', value: 'Group' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'IB_ID', value: 'Agent' },
                { key: 'IB_NAME', value: 'Agent Name' },
                { key: 'OFFICE_NAME', value: 'Office Name' },
                { key: 'OID', value: 'Office ID' },
                { key: 'ACC_NAME', value: 'Region Name' },
                { key: 'RID', value: 'Region ID' },
                { key: 'ZIPCODE', value: 'Zip' },
                { key: 'ADDRESS', value: 'Address' },
                { key: 'EMAIL', value: 'Email' },
                { key: 'PHONE', value: 'Phone' },
                { key: 'COMMENT', value: 'Comment' },
                { key: 'REGDATE', value: 'Reg.date' },
                { key: 'LEVERAGE', value: 'Leverage' },
                { key: 'BALANCE', value: 'Balance' },
                { key: 'CREDIT', value: 'Credit' }
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/manager-report/mt4AccountReport.js